<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bolder text-brand-1 texto-titulo">
          Consulta Ficha de EPIs
        </p>
      </div>
    </div>
    <div class="row col-xs-12 container-usuarios">
      <p style="font-size: 16px" class="text-brand-1 texto-titulo">
        Selecione o(s) usuário(s) para exportar a Ficha de EPI
      </p>
    </div>
    <div class="row col-12 text-brand-1">
      <div class="col-md-5 col-sm-5 col-xs-5">
        <q-select
          v-model="usuario"
          :options="listaUsuariosOptions"
          dense
          outlined
          class="input-new-design"
          label="Digite o nome do usuário que deseja incluir na Ficha de EPI"
          use-input
          option-label="name"
          option-value="id"
          :disable="unidade.id == '' ? true : false"
          hide-selected
          input-debounce="0"
          @filter="filterFn"
        />
        <div class="q-ml-sm hint-text text-red">
          {{
            unidade.id
              ? mensagemInput
              : "*Selecione uma unidade para poder filtrar um Usuario"
          }}
        </div>
      </div>
      <div style="min-width: 270px" class="col-md-2">
        <q-toggle
          label="Mostrar Deletados e afastados"
          left-label
          false-value=""
          class="q-ml-sm"
          color="brand-1"
          v-model="filtros.estado"
          size="md"
        />
      </div>
      <div style="min-width: 270px" class="col-md-2">
        <q-toggle
          label="Buscar Em Todas Unidades"
          left-label
          class="q-ml-sm"
          color="brand-1"
          v-model="filtros.buscarTodasUnidades"
          size="md"
        />
      </div>
    </div>
    <div class="row col-12 q-ml-md q-mt-md text-brand-5 text-weight-bold">
      <div v-for="(usuario, index) in listaUsuarios" :key="index">
        <span class="row q-mr-sm q-mt-md items-center card-nome-usuario"
          >{{ usuario.name
          }}<q-icon
            style="cursor: pointer"
            class="q-ml-sm"
            name="close"
            size="18px"
            @click="removerUsuario(usuario.id)"
        /></span>
      </div>
    </div>
    <div class="row col-xs-12 container-usuarios">
      <p style="font-size: 16px" class="text-brand-1 texto-titulo">
        Selecione as configurações para a Ficha de EPI
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
        ></lista-unidades-select>
      </div>
      <div
        class="col-lg-3 col-md-3 col-sm-5 col-xs-5 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Inicial</div>
        <q-input
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          v-model="filtros.dataInicial"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataInicial"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div
        class="col-lg-3 col-md-3 col-sm-5 col-xs-5 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Final</div>
        <q-input
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          v-model="filtros.dataFinal"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataFinal"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>

    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>
        <q-select
          class="input-new-design"
          dense
          outlined
          v-model="centroCustoSelecionado"
          :options="listaCentrosCustoOptions"
          option-label="name"
          option-value="id"
          emit-value
          map-options
          use-input
          clearable
          hide-selected
          fill-input
          input-debounce="0"
          :disable="!!funcaoSelecionada"
          @filter="filterCentroCustoFn"
        />
      </div>
      <div
        class="col-lg-3 col-md-3 col-sm-5 col-xs-5 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Função</div>
        <q-select
          class="input-new-design"
          dense
          outlined
          v-model="funcaoSelecionada"
          :options="listaFuncoesOptions"
          option-label="name"
          option-value="id"
          emit-value
          map-options
          use-input
          clearable
          hide-selected
          fill-input
          input-debounce="0"
          :disable="!!centroCustoSelecionado"
          @filter="filterFuncaoFn"
        />
      </div>
    </div>
    <div class="row q-mt-sm carrossel-desktop">
      <div
        style="align-items: center"
        class="row q-my-lg justify-between items-center"
      >
        <span class="texto-titulo-tabela text-brand-1 text-subtitle1">
          Arquivos da Ficha:
        </span>
      </div>
      <div class="row col-6 q-ml-sm">
        <div
          style="width: 450px"
          v-if="arquivos.length > 0"
          class="col-6 justify-center"
        >
          <div class="col-6 q-pa-md">
            <q-carousel
              animated
              v-model="slide"
              arrows
              height="200px"
              control-type="regular"
              infinite
              control-color="brand-1"
            >
              <q-carousel-slide
                v-for="(imagem, index) in arquivos"
                :key="index"
                :name="index"
                :img-src="
                  imagem.url.indexOf('pdf') != -1
                    ? require('../../../assets/pdfIcon.png')
                    : imagem.url.indexOf('xml') != -1
                    ? require('../../../assets/exelIcon.png')
                    : imagem.url.indexOf('png') != -1
                    ? require('../../../assets/extensao-png.png')
                    : imagem.url.indexOf('zip') != -1
                    ? require('../../../assets/extensao-zip.png')
                    : imagem.url.indexOf('jpeg') != -1
                    ? require('../../../assets/extensao-jpeg.png')
                    : imagem.url
                "
              >
                <div class="absolute-bottom custom-caption">
                  <div class="text-h4">{{ imagem.descricao_ficha }}</div>
                  <div v-if="imagem.created_at" class="text-subtitle1">
                    {{
                      imagem.created_at
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/") +
                      " " +
                      imagem.created_at.split(" ")[1]
                    }}
                  </div>
                </div>
              </q-carousel-slide>
              <template v-slot:control>
                <q-carousel-control position="bottom-right" :offset="[7, 18]">
                  <q-btn
                    push
                    round
                    dense
                    color="white"
                    text-color="primary"
                    icon="arrow_downward"
                    @click="baixarArquivo(slide)"
                  />
                </q-carousel-control>
                <q-carousel-control
                  position="bottom-left"
                  :offset="[1, 18]"
                  class="q-gutter-xs"
                >
                  <q-btn
                    push
                    round
                    dense
                    flat
                    color="red"
                    icon="delete"
                    @click="recebeImagemUuid(slide)"
                  />
                </q-carousel-control>
              </template>
            </q-carousel>
          </div>
        </div>
        <div class="row items-center">
          <div class="col-12">
            <label
              class="btn info row col-12 justify-center"
              for="arquivo"
              style="cursor: pointer"
            >
              <div class="row col-12 justify-center">
                <q-btn
                  icon="upload"
                  label="Fazer upload de arquivo"
                  no-caps
                  color="brand-2"
                  style="z-index: -1; border-radius: 8px"
                />
              </div>
            </label>
            <input id="arquivo" type="file" @change="onFileSelected" />
          </div>
        </div>
      </div>
    </div>

    <div style="align-items: center" class="row q-mt-md">
      <span style="cursor: not-allowed">
        <q-btn
          color="white"
          label="Baixar de todos os usuários"
          outline
          style="border-radius: 8px; pointer-events: none"
          class="bg-brand-1"
          no-caps
          icon="download"
          :disable="bloqueiaExportFicha"
          @click="solicitarExport('todos')"
        />
        <q-tooltip v-if="bloqueiaExportFicha">
          Você não possui permissão para exportar todas as fichas
        </q-tooltip>
      </span>
      <span class="q-ml-sm">
        <q-btn
          color="white"
          label="Baixar apenas os usuários selecionados"
          outline
          class="bg-brand-2"
          style="border-radius: 8px"
          no-caps
          icon="download"
          :disable="bloqueiaExportFicha"
          @click="baixarUsuarios(true)"
        />
      </span>

      <div
        v-if="!$store.state.autenticacao.cliente.includes('dexco')"
        class="q-ml-sm"
      >
        <q-btn
          color="white"
          label="Visualizar"
          outline
          class="bg-brand-1"
          no-caps
          style="border-radius: 8px"
          icon="visibility"
          :disable="dadosUsuario.length == 0"
          @click="visualizar = true"
        />
      </div>
      <div
        v-if="!$store.state.autenticacao.cliente.includes('dexco')"
        class="q-ml-sm"
      >
        <router-link
          v-if="dadosUsuario.length > 0"
          :to="{
            name: 'seguranca-impressao-fichadeepi',
            params: {
              unidadeId: unidade.id,
              solicitanteId: usuario.id,
              solicitanteSap: usuario.sap,
              solicitanteName: usuario.name,
              dataInicial: filtros.dataInicial,
              dataFinal: filtros.dataFinal,
            },
          }"
          target="_blank"
        >
          <q-btn
            label="Imprimir"
            color="white"
            outline
            style="border-radius: 8px"
            class="bg-brand-2"
            no-caps
            icon="print"
          />
        </router-link>
        <q-btn
          v-else
          label="Imprimir"
          outline
          class="bg-brand-2"
          no-caps
          style="border-radius: 8px"
          color="white"
          icon="print"
          disable
        />
      </div>
    </div>

    <!-- modal de confirmacao de export -->
    <q-dialog v-model="confirmacaoExport" persistent>
      <q-card
        class="q-pa-sm text-brand-5 text-weight-bolder"
        style="max-width: 700px"
      >
        <q-card-section class="row items-center">
          <q-icon name="info" color="brand-1" size="2.5rem" class="q-mr-sm" />
          <span class="text-h6">Exportação de Fichas de EPI</span>
        </q-card-section>
        <q-card-section style="font-size: 1.1rem; line-height: 1.6">
          Você está solicitando o export de fichas de EPI, este processamento
          acontecerá em segundo plano e poderá demorar em torno de 30 minutos.
          Assim que finalizado, você será notificado por email com o link para
          download e também poderá acessar o arquivo pela central de Downloads.
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            no-caps
            outline
            label="REVISAR FILTROS"
            color="negative"
            style="padding: 8px 20px; font-size: 0.9rem"
            v-close-popup
          />
          <q-btn
            no-caps
            outline
            label="CONTINUAR"
            color="positive"
            style="padding: 8px 20px; font-size: 0.9rem"
            v-close-popup
            @click="confirmarExport()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- modal de bloqueio para tenants Vale -->
    <q-dialog v-model="modalBloqueioVale" persistent>
      <q-card
        class="q-pa-sm text-brand-5 text-weight-bolder"
        style="max-width: 780px"
      >
        <q-card-section class="row items-center">
          <q-icon
            name="warning"
            color="negative"
            size="2.5rem"
            class="q-mr-sm"
          />
          <span class="text-h6">Ação indisponível</span>
        </q-card-section>
        <q-card-section style="font-size: 1rem; line-height: 1.6">
          O download das fichas de EPI de todas as unidades está temporariamente
          indisponivel, por favor selecione um Centro de Custo, um GHE ou então
          alguns funcionários especificos para processar as fichas.
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            no-caps
            dense
            outline
            label="Fechar"
            color="negative"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <div class="container-tabela-informacoes q-ml-md">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Informações do usuário
        </span>
      </div>
      <q-table
        :columns="columns"
        :rows="dadosUsuario"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        :loading="loading"
        hide-bottom
      >
        <template v-slot:body-cell-nomeUsuario="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-SolicitanteSap="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.sap }}
          </q-td>
        </template>
        <template v-slot:body-cell-dataAdmissao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.admission_date
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-cargo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.cargo }}
          </q-td>
        </template>
        <template v-slot:body-cell-ghe="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.function_model?.name }}
          </q-td>
        </template>
      </q-table>
    </div>

    <div class="container-tabela-itens">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Itens retirados
        </span>
      </div>
      <q-table
        :columns="columns2"
        :rows="dadosFichaEpi"
        color="primary"
        style="max-height: 500px"
        :loading="loading"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-planta="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.EntregaUnidadeNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcaoGhe="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.SolicitanteFuncao }}
          </q-td>
        </template>
        <template v-slot:body-cell-centroCusto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.CentroCustoCodigo }} - {{ props.row.CentroCustoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-area="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.CentroCustoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-responsavelCentroCusto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.CentroCustoResponsavel }}
          </q-td>
        </template>
        <template v-slot:body-cell-entregueEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              (props.row.RetiradoPorData &&
              props.row.RetiradoPorData.trim() !== ""
                ? props.row.RetiradoPorData
                : props.row.FinalizacaoData
              )
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.ItemGrupoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.ItemQuantidade }}
          </q-td>
        </template>
        <template v-slot:body-cell-requisicao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.AprovacaoAutenticacaoTipo }}
          </q-td>
        </template>

        <template v-slot:body-cell-autenticacaoCriacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span
              v-if="
                props.row.RequisicaoAutenticacaoTipo != 'biometria' &&
                props.row.RequisicaoAutenticacaoTipo != 'assinatura' &&
                props.row.RequisicaoAutenticacaoTipo != 'facial'
              "
              >Assinado eletronicamente</span
            >
            <span v-else>
              <q-img
                :src="props.row.RequisicaoAutenticacao"
                style="max-width: 300px; height: 70px"
                fit="contain"
              >
              </q-img
            ></span>
          </q-td>
        </template>
        <template v-slot:body-cell-autenticacaoFinalizacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span
              v-if="
                (props.row.RetiradoPorAutenticacaoTipo ??
                  props.row.FinalizacaoAutenticacaoTipo) != 'biometria' &&
                (props.row.RetiradoPorAutenticacaoTipo ??
                  props.row.FinalizacaoAutenticacaoTipo) != 'assinatura' &&
                (props.row.RetiradoPorAutenticacaoTipo ??
                  props.row.FinalizacaoAutenticacaoTipo) != 'facial'
              "
              >Assinado eletronicamente</span
            >
            <span v-else>
              <q-img
                :src="
                  props.row.RetiradoPorAutenticacao ??
                  props.row.FinalizacaoAutenticacao
                "
                style="max-width: 300px; height: 70px"
                fit="contain"
              >
              </q-img
            ></span>
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog
      v-model="visualizar"
      transition-show="rotate"
      transition-hide="rotate"
    >
      <q-card style="max-width: 95vw">
        <q-card-section>
          <div class="row col-12">
            <div style="width: 18%" class="column justify-around top q-mb-sm">
              <q-img
                v-if="dadosDescricao?.url_logo"
                :src="dadosDescricao?.url_logo"
              />
              <q-img v-else src="../../../assets/MULTPEX_VETOR.png" />
            </div>
          </div>
          <q-table
            :columns="columns"
            :rows="dadosUsuario"
            dense
            color="primary"
            table-header-class="bg-white text-black text-weight-bold"
            hide-bottom
          >
            <template v-slot:body-cell-nomeUsuario="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.name }}
              </q-td>
            </template>
            <template v-slot:body-cell-SolicitanteSap="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.sap }}
              </q-td>
            </template>
            <template v-slot:body-cell-dataAdmissao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  props.row.admission_date
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-cargo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.cargo }}
              </q-td>
            </template>
            <template v-slot:body-cell-ghe="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row?.function_model?.name }}
              </q-td>
            </template>
          </q-table>
          <q-table
            class="q-mt-md"
            :columns="columns2"
            :rows="dadosFichaEpi"
            color="primary"
            table-header-class="bg-white text-black text-weight-bold"
            flat
            dense
            hide-bottom
            :rows-per-page-options="[0]"
          >
            <template v-slot:body-cell-planta="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.EntregaUnidadeNome }}
              </q-td>
            </template>
            <template v-slot:body-cell-funcaoGhe="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.SolicitanteFuncao }}
              </q-td>
            </template>
            <template v-slot:body-cell-centroCusto="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.CentroCustoNome }}
              </q-td>
            </template>
            <template v-slot:body-cell-RequisicaoNumero="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.RequisicaoNumero }}
              </q-td>
            </template>
            <template v-slot:body-cell-responsavelCentroCusto="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.CentroCustoResponsavel }}
              </q-td>
            </template>
            <template v-slot:body-cell-entregueEm="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  props.row.RetiradoPorData?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-ItemCodigo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  >{{ props.row.ItemCodigo.slice(0, 20) }}
                  <q-tooltip>
                    {{ props.row.ItemCodigo }}
                  </q-tooltip>
                </span>
              </q-td>
            </template>

            <template v-slot:body-cell-ItemNomeContrato="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  >{{ props.row?.ItemNomeContrato?.slice(0, 20) }}
                  <q-tooltip>
                    {{ props.row.ItemNomeContrato }}
                  </q-tooltip>
                </span>
              </q-td>
            </template>
            <template v-slot:body-cell-ItemCaCodigo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.ItemCaCodigo }}
              </q-td>
            </template>
            <template v-slot:body-cell-quantidade="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  Number(props.row.ItemQuantidade?.replace(",", ".")).toFixed(0)
                }}
              </q-td>
            </template>

            <template v-slot:body-cell-autenticacaoCriacao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  v-if="
                    props.row.RequisicaoAutenticacaoTipo != 'biometria' &&
                    props.row.RequisicaoAutenticacaoTipo != 'assinatura' &&
                    props.row.RequisicaoAutenticacaoTipo != 'facial'
                  "
                  >Assinado eletronicamente</span
                >
                <span v-else>
                  <q-img
                    :src="props.row.RequisicaoAutenticacao"
                    style="max-width: 300px; height: 70px"
                    fit="contain"
                  >
                  </q-img
                ></span>
              </q-td>
            </template>
            <template v-slot:body-cell-autenticacaoFinalizacao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  v-if="
                    (props.row.RetiradoPorAutenticacaoTipo ??
                      props.row.FinalizacaoAutenticacaoTipo) != 'biometria' &&
                    (props.row.RetiradoPorAutenticacaoTipo ??
                      props.row.FinalizacaoAutenticacaoTipo) != 'assinatura' &&
                    (props.row.RetiradoPorAutenticacaoTipo ??
                      props.row.FinalizacaoAutenticacaoTipo) != 'facial'
                  "
                  >Assinado eletronicamente</span
                >
                <span v-else>
                  <q-img
                    :src="
                      props.row.RetiradoPorAutenticacao ??
                      props.row.FinalizacaoAutenticacao
                    "
                    style="max-width: 300px; height: 70px"
                    fit="contain"
                  >
                  </q-img
                ></span>
              </q-td>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja adicionar essa imagem?</span
          >
        </q-card-section>

        <q-card-section class="q-ml-sm row items-center">
          <q-input
            style="width: 100%"
            dense
            outlined
            label="Descrição"
            v-model="descricao"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="adicionarImagem()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";

const columns = [
  {
    name: "nomeUsuario",
    label: "Nome Usuário",
    align: "left",
  },
  {
    name: "SolicitanteSap",
    label: "SAP Usuário",
    align: "left",
  },
  {
    name: "dataAdmissao",
    label: "Data Admissão",
    align: "left",
  },
  {
    name: "cargo",
    label: "Cargo",
    align: "left",
  },
  {
    name: "ghe",
    label: "GHE",
    align: "left",
  },
];
const columns2 = [
  {
    name: "planta",
    label: "Planta",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "funcaoGhe",
    label: "Função (GHE)",
    style: "white-space: normal",
    align: "left",
  },
  {
    name: "centroCusto",
    label: "Centro de Custo",
    style: "white-space: normal",
    align: "left",
  },
  {
    name: "RequisicaoNumero",
    label: "Numero Requisição",
    align: "left",
    field: "RequisicaoNumero",
    style: "white-space: normal",
  },

  {
    name: "entregueEm",
    label: "Data de Entrega",
    field: "RetiradoPorData",
    style: "white-space: normal",
    align: "left",
  },

  {
    name: "ItemCodigo",
    label: "Codigo Produto",
    align: "left",
    style: "width: 90px",
    field: "ItemCodigo",
  },

  {
    name: "ItemNomeContrato",
    label: "Descrição Produto",
    align: "left",
    style: "white-space: normal",
    field: "ItemNomeContrato",
  },
  {
    name: "ItemCaCodigo",
    label: "CA",
    align: "left",
    style: "white-space: normal",
    field: "ItemCaCodigo",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    style: "white-space: normal",
    align: "left",
  },

  {
    name: "autenticacaoCriacao",
    style: "height: 70px; white-space: normal",
    label: "Autenticação Criação",
    align: "rigth",
  },
  {
    name: "autenticacaoFinalizacao",

    style: "height: 70px; white-space: normal",

    label: "Autenticação Finalização.",
    align: "rigth",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const router = useRouter();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const filtros = ref({
      dataInicial: "01/01/2001",
      dataFinal: new Date()
        .toISOString()
        .substring(0, 10)
        .split("-")
        .reverse()
        .join("/"),
      estado: "",
      centro: "",
      funcao: "",
      buscarTodasUnidades: usuarioTemPermissao(
        store,
        "ficha-epi-buscar-todos-funcionarios"
      ),
    });
    const listaUsuariosOptions = ref([]);
    const usuario = ref("");
    const mensagemInput = ref("*nome completo do usuário para ficha de EPI");
    const listaUsuarios = ref([]);
    const dadosFichaEpi = ref([]);
    const dadosUsuario = ref([]);
    const arquivos = ref([]);
    const quasar = useQuasar();
    const imageUrl = ref("");
    const confirm = ref(false);
    const dadosDescricao = ref(null);
    const time = ref();
    const file = ref(null);
    let slide = ref(0);
    const descricao = ref("");
    let loading = ref(false);
    let visualizar = ref(false);
    const centroCustoSelecionado = ref(null);
    const funcaoSelecionada = ref(null);
    const modalBloqueioVale = ref(false);
    const confirmacaoExport = ref(false);
    const acaoPendente = ref("");

    const bloqueiaExportFicha = computed(() =>
      usuarioTemPermissao(store, "bloqueia_export_ficha")
    );

    const listarUsuarios = async (busca) => {
      mensagemInput.value = "*nome completo do usuário para ficha de EPI";

      const params = {
        per_page: 10,
        search: busca,
        deleted: filtros.value.estado,
      };

      const podeVerTodos =
        filtros.value.buscarTodasUnidades ||
        usuarioTemPermissao(store, "visualizar_todos_usuários");
      if (!podeVerTodos) {
        params.vendor_id = unidade.value.id;
      }

      const response = await store.dispatch("seguranca/listarUsuarios", params);

      listaUsuariosOptions.value = [];
      listaUsuariosOptions.value = response.data.results.data;
      if (listaUsuariosOptions.value.length == 0) {
        mensagemInput.value = "Nenhum usuário encontrado";
        return;
      }
    };

    const listarDadosFichaEpi = async () => {
      quasar.loading.show();
      if (dadosUsuario?.value[0]?.id == undefined) {
        quasar.loading.hide();
        return;
      }
      try {
        loading.value = true;
        const response = await store.dispatch("seguranca/listarDadosFichaEpi", {
          dataFinal: filtros.value.dataFinal,
          dataInicial: filtros.value.dataInicial,
          epi: 1,
          per_page: 1000,
          solicitanteId: dadosUsuario.value[0].id,
          solicitanteSap: dadosUsuario.value[0].sap,
        });
        getArquivos();
        if (response.data.return.data) {
          dadosFichaEpi.value = response.data.return.data;
        }
        loading.value = false;
        listarDescricao();
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
      }
    };

    const removerUsuario = async (id) => {
      usuario.value = "";
      listaUsuarios.value = listaUsuarios.value.filter((user) => user.id != id);
      if (listaUsuarios.value.length == 0) {
        dadosFichaEpi.value = [];
        dadosUsuario.value = [];
        return;
      }
      dadosUsuario.value = [listaUsuarios.value[0]];
      listarDadosFichaEpi();
    };

    const imprimirFichaEpi = () => {
      router.push({
        name: "seguranca-impressao-ficha",
        params: { solicitanteId: dadosUsuario.value[0].id },
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    watch(
      () => usuario.value,
      () => {
        if (usuario.value == null || usuario.value == "") {
          return;
        }
        if (listaUsuarios.value.length > 0) {
          if (listaUsuarios.value.some((user) => user.id == usuario.value.id)) {
            mensagemInput.value = "usuário já adicionado";
            return;
          }
          listaUsuarios.value.push(usuario.value);
          dadosUsuario.value = [listaUsuarios.value[0]];
          listarDadosFichaEpi();
          return;
        }
        listaUsuarios.value.push(usuario.value);
        dadosUsuario.value = [listaUsuarios.value[0]];
        listarDadosFichaEpi();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    const getArquivos = async () => {
      slide.value = 0;
      const response = await store.dispatch("seguranca/getArquivos", {
        user_id: dadosUsuario.value[0].id,
      });
      arquivos.value = response.data.data.data;
    };

    const baixarUsuarios = async (todos = false) => {
      if (
        todos &&
        listaUsuarios.value.length === 0 &&
        !centroCustoSelecionado.value &&
        !funcaoSelecionada.value
      ) {
        quasar.notify({
          message: "Selecione um usuário",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        return;
      }

      try {
        const vendorId = store.state.org.unidadeData.id;
        const dataInicial = filtros.value.dataInicial
          .split("/")
          .reverse()
          .join("-");
        const dataFinal = filtros.value.dataFinal
          .split("/")
          .reverse()
          .join("-");

        let payload;

        if (centroCustoSelecionado.value) {
          payload = {
            group_type: "COST_CENTER",
            group_id: String(centroCustoSelecionado.value),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else if (funcaoSelecionada.value) {
          payload = {
            group_type: "FUNCTION",
            group_id: String(funcaoSelecionada.value),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else if (todos && listaUsuarios.value.length > 0) {
          const userIds = listaUsuarios.value.map((e) => String(e.id));
          payload = {
            group_type: "EMPLOYEE",
            group_id: userIds,
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else {
          payload = {
            group_type: "VENDOR",
            group_id: String(vendorId),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        }

        await store.dispatch("seguranca/baixarUsuarios", payload);

        quasar.notify({
          message: "Download solicitado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      } catch (error) {
        const errosApi = error?.response?.data?.errors;
        const mensagemErro =
          errosApi?.length > 0
            ? "Já existe um pedido de export de ficha de EPI para seu usuário, por favor aguarde o processamento do mesmo, consulte a central de downloads ou a lista de acompanhamento"
            : "Erro ao fazer download";
        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const handleBaixarTodosUsuarios = () => {
      const cliente = store.state.autenticacao.cliente;
      if (
        (cliente.includes("staging-vale") ||
          cliente.includes("vale-epiexpress")) &&
        listaUsuarios.value.length === 0 &&
        !centroCustoSelecionado.value &&
        !funcaoSelecionada.value
      ) {
        modalBloqueioVale.value = true;
      } else {
        baixarUsuarios(false);
      }
    };

    const solicitarExport = (acao) => {
      acaoPendente.value = acao;
      confirmacaoExport.value = true;
    };

    const confirmarExport = () => {
      if (acaoPendente.value === "todos") {
        handleBaixarTodosUsuarios();
      } else {
        baixarUsuarios(true);
      }
    };

    const recebeImagemUuid = async (id) => {
      try {
        await store.dispatch("seguranca/deletarArquivo", {
          uuid: arquivos.value[id].uuid_arquivo,
        });

        quasar.notify({
          message: "Arquivo deletado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getArquivos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao deletar arquivo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
      confirm.value = true;
    };

    watch(
      () => file.value,
      () => {
        if (file.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(file.value);
          fileReader.addEventListener("load", () => {
            imageUrl.value = fileReader.result;
          });
        }
      }
    );

    watch(
      [() => filtros.value.dataInicial, () => filtros.value.dataFinal],
      () => {
        listarDadosFichaEpi();
      }
    );

    const adicionarImagem = async () => {
      try {
        await store.dispatch("seguranca/subirArquivo", {
          imagem: imageUrl.value,
          user_id: dadosUsuario.value[0].id,
          descricao: descricao.value,
        });
        getArquivos();
        quasar.notify({
          message: "Arquivo adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        descricao.value = "";
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar arquivo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getUnidade);

    const listarDescricao = async () => {
      const response = await store.dispatch("seguranca/getDescricao", {
        vendor_id: unidade.value.id,
      });

      dadosDescricao.value = response.data.response;
    };

    const baixarArquivo = async (id) => {
      const response = await store.dispatch("seguranca/baixarArquivo", {
        uuid: arquivos.value[id].uuid_arquivo,
      });

      window.open(response.data.data, "_blank");
    };

    const listaCentrosCustoOptions = ref([]);
    const listaFuncoesOptions = ref([]);

    const filterCentroCustoFn = async (val, update, abort) => {
      clearTimeout(time.value);
      if (val.length < 1) {
        abort();
        return;
      }

      time.value = setTimeout(async () => {
        const response = await store.dispatch("seguranca/listarCentrosCusto", {
          search: val,
        });
        listaCentrosCustoOptions.value = response.data.results.data;
        update();
      }, 2000);
    };

    const filterFuncaoFn = async (val, update, abort) => {
      clearTimeout(time.value);
      if (val.length < 1) {
        abort();
        return;
      }

      time.value = setTimeout(async () => {
        const response = await store.dispatch("seguranca/listarFuncoes", {
          search: val,
        });
        listaFuncoesOptions.value = response.data.results.data;
        update();
      }, 2000);
    };

    return {
      columns,
      columns2,
      unidade,
      slide,
      recebeImagemUuid,
      confirm,
      adicionarImagem,

      filtros,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      listarUsuarios,
      usuario,
      listaUsuariosOptions,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarUsuarios(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      mensagemInput,
      listaUsuarios,
      removerUsuario,
      listarDadosFichaEpi,
      dadosFichaEpi,
      dadosUsuario,
      onFileSelected,
      loading,
      imprimirFichaEpi,
      visualizar,
      dadosDescricao,
      arquivos,
      baixarArquivo,
      descricao,
      time,
      baixarUsuarios,
      listaCentrosCustoOptions,
      listaFuncoesOptions,
      filterCentroCustoFn,
      filterFuncaoFn,
      centroCustoSelecionado,
      funcaoSelecionada,
      modalBloqueioVale,
      handleBaixarTodosUsuarios,
      confirmacaoExport,
      solicitarExport,
      confirmarExport,
      bloqueiaExportFicha,
    };
  },
};
</script>

<style>
.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
input[type="file"] {
  display: none;
}

.q-carousel__slide {
  background-size: contain;
  background-repeat: no-repeat;
}
.container-usuarios {
  margin: 30px 0px -5px 0px;
}
.hint-text {
  font-size: 11px;
}

.texto-titulo-input {
  color: #21324a;
}

.card-nome-usuario {
  background-color: #7ab9e0;
  color: white;
  padding: 5px 10px;
  border-radius: 8px;
}
.container-tabela-informacoes {
  margin: 70px 0px 0px 0px;
}
.container-tabela-itens {
  margin: 70px 0px 0px 0px;
}
a {
  text-decoration: none;
}
.custom-caption {
  text-align: center;
  padding: 12px;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
